import { SUB_THEMES } from "./AgGridSalesBlock";

/**
 *
 * This function iterates through the received data and maps its `theme`
 * property along with sub-themes into row objects.
 *
 * @param {Array} data - An array of objects received from the backend, where each object contains a `theme` property and a `subThemes` array.
 * @param {Function} setRowsData - A state setter function that updates the rows data array.
 */
export const convertBackendDataToRows = (data, setRowsData) => {
  for (const element of data) {
    const theme = element.theme;

    for (const subElement of element.subThemes) {
      let obj = {
        theme: theme,
        subTheme: subElement.name,
      };

      if (subElement.inputs && subElement.inputs.length > 0) {
        const monthsData = {};

        for (const input of subElement.inputs) {
          const monthRow = generateMonthRows(input);

          // Fusionner avec les données existantes
          for (let i = 1; i <= 12; i++) {
            if (monthRow[i] && monthRow[i].amount !== null) {
              monthsData[i] = monthRow[i];
            } else if (!monthsData[i]) {
              monthsData[i] = null;
            }
          }
        }

        Object.assign(obj, monthsData);
      }

      setRowsData((p) => [...p, obj]);
    }
  }
};

export const generateMonthRows = (month = {}) => {
  const row = {};

  for (let i = 1; i <= 12; i++) {
    if (i === month.fiscal_month) {
      row[i] = {
        amount: month.value,
        id: month.id,
      };
    } else {
      row[i] = {
        amount: null,
        id: null,
      };
    }
  }

  return row;
};

export const calculatePriceWithRateIncrease = (
  price,
  ratioPrice,
  rateIncrease,
) => {
  return Math.ceil(price * ratioPrice * (1 + rateIncrease / 100));
};

export const getRowDataNumber = (rowName, fiscalMonthIndex, api) => {
  return Number(api.getRowNode(rowName)?.data?.[fiscalMonthIndex] || 0);
};

export const getPcRateIncrease = (rateIncreaseData, fiscalMonthIndex) => {
  if (!rateIncreaseData) return 0;

  const rateIncreaseObj = rateIncreaseData.find(
    (item) => item[fiscalMonthIndex] !== undefined,
  );

  return rateIncreaseObj ? Number(rateIncreaseObj[fiscalMonthIndex]) : 0;
};

/**
 * Updates the data of a node in the API and returns the new value.
 *
 * @param {Object} api - The API object that provides access to the data.
 * @param {string} nodeId - The ID of the node to be updated.
 * @param {string} fiscalMonthIndex - The index of the fiscal month to be updated.
 * @param {*} value - The new value to be set for the specified fiscal month.
 * @returns {number} The updated value.
 */
export const updateNodeDataAndReturn = (
  api,
  nodeId,
  fiscalMonthIndex,
  value,
) => {
  const row = api.getRowNode(nodeId)?.data;

  if (row) {
    row[fiscalMonthIndex] = value;
  }

  return value;
};

// Calcul  external volumes
export const calculateExternalVolumes = (api, fiscalMonthIndex) => {
  const externalCashRow = api.getRowNode(SUB_THEMES.EXTERNAL_CASH)?.data;
  const externalCreditRow = api.getRowNode(SUB_THEMES.EXTERNAL_CREDIT)?.data;

  if (!externalCashRow || !externalCreditRow) return null;

  const externalCash = Number(externalCashRow[fiscalMonthIndex] || 0);
  const externalCredit = Number(externalCreditRow[fiscalMonthIndex] || 0);

  return externalCash + externalCredit;
};

// Calcul internal volumes
export const calculateInternalVolumes = (api, fiscalMonthIndex) => {
  const internalRow = api.getRowNode(SUB_THEMES.INTERNAL)?.data ?? 0;
  const quotePartRow_TR = api.getRowNode(SUB_THEMES.TR)?.data ?? 0;
  const quotePartRow_VA = api.getRowNode(SUB_THEMES.VA)?.data ?? 0;

  return (
    Number([quotePartRow_TR[fiscalMonthIndex] || 0]) +
    Number([quotePartRow_VA[fiscalMonthIndex] || 0]) +
    Number(internalRow[fiscalMonthIndex] || 0)
  );
};
